export default __webpack_public_path__ + "static/media/orangeTheme-girl.af6ec93a.svg";